import React from 'react';
import { Edit } from 'react-admin';
import PropTypes from 'prop-types';
import Form from './detail/Form';

// Appelé comme une fonction par DrawerCreateEdit (`renderEdit(...)`) : aucun
// hook ici.
//
// `pessimistic` : l'écriture part au clic sur Enregistrer. Un refus du contrôle
// de modification (plan 070b, Q19) laisse alors le tiroir ouvert avec la
// saisie ; en `undoable` (défaut de react-admin), le tiroir serait déjà fermé.
const PreaffectationEdit = ({ basePath, ...props }) => {
  return (
    <Edit
      {...props}
      basePath={basePath}
      redirect="list"
      mutationMode="pessimistic"
    >
      <Form {...props} redirect="list" />
    </Edit>
  );
};

PreaffectationEdit.propTypes = {
  basePath: PropTypes.string,
};

PreaffectationEdit.defaultProps = {
  basePath: '',
};

export default PreaffectationEdit;
